import React from "react";
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import { BodyParagraph } from "theme/components/atoms/Typography/Body";
import Button from "theme/components/atoms/Button";
import LabelledIcon from "theme/components/molecules/LabelledIcon";
import FormActions from "theme/components/molecules/Form/FormActions";
import Stack from "theme/components/atoms/Layout/Stack";

const messages = defineMessages({
  allowCookies: {
    id: "modules.Cookie.CookieNotice.allowCookies",
    defaultMessage: "Allow all the cookies",
  },
  denyCookies: {
    id: "modules.Cookie.CookieNotice.denyCookies",
    defaultMessage: "Deny all the cookies",
  },
  readMore: {
    id: "modules.Cookie.CookieNotice.readMore",
    defaultMessage: "Read more",
  },
});

const CookieNotice = ({ authorizeAll, denyAll, intl, showModal }) => {
  return (
    <div className="cookie-notice">
      <Stack size="1">
        <div className="cookie-notice__content">
          <BodyParagraph>
            <FormattedMessage
              id="modules.Cookie.CookieNotice.description"
              defaultMessage="Cookies ensure the proper operation of our services. By using these, you accept the use of cookies"
            />
          </BodyParagraph>
        </div>
        <FormActions appearance="center">
          <Button onClick={() => showModal(true)} size="small">
            <LabelledIcon icon="list" appearance="block">
              {intl.formatMessage(messages.readMore)}
            </LabelledIcon>
          </Button>
          {denyAll ? (
            <Button onClick={denyAll} size="small">
              <LabelledIcon icon="cross-circle" appearance="block">
                {intl.formatMessage(messages.denyCookies)}
              </LabelledIcon>
            </Button>
          ) : null}
          <Button onClick={authorizeAll} appearance="primary" size="small">
            <LabelledIcon icon="checkmark-circle" appearance="block">
              {intl.formatMessage(messages.allowCookies)}
            </LabelledIcon>
          </Button>
        </FormActions>
      </Stack>
    </div>
  );
};

export default injectIntl(CookieNotice);
